export function map() {
    const body = $('body');
    const path = $('.map-states path');
    const closeMap = $('.close-map');
    const tooltipSpan = document.querySelector('.tooltip-title');
    const mapHolder = document.querySelector(".map-section");
    let locations;

    function initMap() {
        let markers = [];
        let mapStyle = [
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ];
        let map = new google.maps.Map(document.getElementById('google-map'), {
            styles: mapStyle,
            scrollwheel: false,
            scaleControl: false,
            draggable: !(typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1),
            disableDoubleClickZoom: true,
            panControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            overviewMapControl: false,
            fullscreenControl: false,
            center: new google.maps.LatLng(locations[0].lat, locations[0].lng),
            zoom: zoom
        });
        let bounds = new google.maps.LatLngBounds();
        let infowindow = new google.maps.InfoWindow();
        let marker, i;

        for (i = 0; i < locations.length; i++) {
            let lat = locations[i].lat;
            let lng = locations[i].lng;
            const markerIcon = {
                url: locations[i].icon,
                scaledSize: new google.maps.Size(39, 58)
            };


            marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map: map,
                icon: markerIcon.url ? markerIcon : null,
                title: locations[i].title

            });
            markers.push(marker);
            bounds.extend(marker.position);
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                const title = locations[i].title ? "<h5>" + locations[i].title + "</h5>" : '';
                const photo = locations[i].photo ? "<div class='photo' style='background-image: url(" + locations[i].photo + ")'></div>" : '';
                const info = locations[i].info ? "<div class='info'>" + locations[i].info + "</div>" : '';
                const link = locations[i].link ? "<a class='see-more white' href=" + locations[i].link + ">View Property Website <svg viewBox=\"0 0 64 64\">\n" +
                    "<circle r=\"25%\" cx=\"50%\" cy=\"50%\"></circle>\n" +
                    "</svg></a>" : '';
                const infoWindowContent = "<div class='info-window'>" +
                    title +
                    info +
                    "<div class='image-holder'>" +
                    photo +
                    link +
                    "</div>" +
                    "</div>";

                return function () {
                    infowindow.setContent(infoWindowContent);
                    infowindow.open(map, marker);
                }
            })(marker, i));
            // map.fitBounds(bounds);
        }
    }

    path.each((index, el) => {
        let activeStates = el.getAttribute('id').slice(3);
        for (let key in mapData) {
            if (activeStates === key) {
                $(el).addClass('active-state');
            }
        }
    });

    $('.active-state').on('click', function () {
        let activeStates = $(this).attr('id').slice(3);
        locations = mapData[activeStates];
        initMap();
        body.addClass('map-show');
        closeMap.addClass('show');
    });

    closeMap.on('click', function () {
        $(this).removeClass('show');
        body.removeClass('map-show');
    });

    //tooltip
    path.mouseenter(function () {
        if ($("body").hasClass("no-touch")) {
            tooltipSpan.textContent = this.getAttribute('title');
            tooltipSpan.classList.add("show");

            mapHolder.onmousemove = function (e) {
                let x = e.clientX;
                let y = e.clientY;
                tooltipSpan.style.top = (y - 5) + 'px';
                tooltipSpan.style.left = (x + 20) + 'px';
            };
        }
    }).mouseleave(function () {
        if ($("body").hasClass("no-touch")) {
            tooltipSpan.classList.remove("show");
        }
    });

    let $filterForm = $('form#filter-properties');
    if ($filterForm.length > 0) {
        $filterForm.on('change', 'select.properties-order', function () {
            $(this).closest('form').submit();
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/map.js